import styled from "styled-components";

import PrimaryButton from "./PrimaryButton.styled";

const OutlinedButton = styled(PrimaryButton)`
  background-color: transparent;
  color: ${(props) => props.theme.colors.primary1};
  border: ${(props) => `1px solid ${props.theme.colors.primary1}`};

  &:hover {
    color: ${(props) => props.theme.colors.baseWhite};
  }

  &:disabled {
    color: ${(props) => props.theme.colors.disabled1};
    background-color: transparent;
    border: ${(props) => `1px solid ${props.theme.colors.disabled1}`};
  }
`;

export default OutlinedButton;
